<template>
  <div style="width: 100%">
    <AppBar :set-mini="setMini"></AppBar>
    <v-navigation-drawer
      v-model="drawer"
      :permanent="!mobile"
      app
      dark
      color="#262b3e"
      clipped
      :bottom="mobile"
      :mini-variant="mini"
    >
      <v-list shaped dense nav>
        <!-- <v-list-item-group color="primary"> -->
        <div v-for="item in items.filter((i) => i.show)" :key="item.title">
          <v-list-group v-if="item.subgroup" :value="true" no-action>
            <template v-slot:activator>
              <v-list-item-icon class="mr-4">
                <v-icon small>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="subitem in item.subgroup.filter((i) => i.show)"
              v-show="noAccess(subitem)"
              :id="subitem.title"
              :key="subitem.title"
              v-model="group"
              :to="subitem.route"
              :class="!mobile && 'px-6'"
              color="#F7941D"
              link
            >
              <!-- <v-list-item-content> -->
              <v-list-item-icon class="mr-4">
                <v-icon small>{{ subitem.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                {{ subitem.title }}
              </v-list-item-title>
              <v-chip
                v-if="subitem.beta"
                color="primary"
                class="px-1"
                style="overflow: visible"
                label
                x-small
                ><span class="white--text">BETA</span></v-chip
              >
              <!-- </v-list-item-content> -->
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            v-show="noAccess(item)"
            :id="item.title"
            v-model="group"
            :to="item.route"
            color="#F7941D"
            link
          >
            <v-list-item-icon class="mr-4">
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item>
        </div>
        <!-- </v-list-item-group> -->
      </v-list>
    </v-navigation-drawer>
    <v-tour
      name="showUnitsTour"
      :steps="tourSteps"
      :options="tourOptions"
      :callbacks="tourCallbacks"
    ></v-tour>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AppBar from './AppBar.vue'
export default {
  name: 'Drawer',
  components: {
    AppBar
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      tourSteps: [
        {
          target: '#Units',
          header: {
            title: 'Create Units'
          },
          content: 'Create your first set of units here.',
          params: {
            placement: 'bottom-end'
          },
          offset: -500
        }
      ],
      tourOptions: {
        startTimeout: 200
      },
      tourCallbacks: {
        onStop: this.stopTourCallback
      },
      noAccessRoles: {
        // add roles: [no-access-items] to hide
        manager: []
      },
      properties: [],
      currentProperty: null,
      loading: false,
      drawer: false,
      group: null,
      mini: false
    }
  },
  computed: {
    items() {
      return [
        {
          title: 'Dashboard',
          icon: 'mdi-view-dashboard-outline',
          route: '/dashboard',
          show: true
        },
        {
          title: 'Calendar',
          icon: 'mdi-calendar',
          route: '/calendar',
          show: this.calendarAccess.read
        },
        {
          title: 'Units',
          icon: 'mdi-office-building',
          route: '/units',
          show: this.unitsAccess.read
        },
        {
          title: 'Complaints',
          icon: 'mdi-image-broken',
          route: '/complaints',
          show: this.complaintsAccess.read
        },
        {
          title: 'Violations',
          icon: 'mdi-alert-outline',
          route: '/violations',
          show: this.violationsAccess.read
        },
        {
          title: 'Reservations',
          icon: 'mdi-clipboard-list-outline',
          route: '/reservations',
          show: this.reservationsAccess.read
        },
        {
          title: 'Transactions',
          icon: 'mdi-account-cash',
          route: '/payments',
          show: this.paymentAccess.read,
          subgroup: [
            {
              title: 'Payments',
              icon: 'mdi-cash-multiple',
              route: '/payments',
              show: this.paymentAccess.read
            },
            {
              title: 'PD Checks',
              icon: 'mdi-checkbook',
              route: '/pdcs',
              show: this.paymentAccess.read
            },
            {
              title: 'Security Deposits',
              icon: 'mdi-cash-lock',
              route: '/security-deposits',
              show: this.securityDepositAccess.read
            },
            {
              title: 'Split View',
              icon: 'mdi-cash-multiple',
              route: '/payments-split',
              show: this.paymentAccess.read,
              beta: true
            },
            {
              title: 'Down Payments',
              icon: 'mdi-cash-marker',
              route: '/down-payments',
              show: this.downPaymentAccess.read
            }
          ]
        },
        {
          title: 'Tenants',
          icon: 'mdi-account-group-outline',
          route: '/tenants',
          show: this.tenantsAccess.read
        },
        {
          title: 'Links',
          icon: 'mdi-link-variant',
          route: '/forms',
          show: this.linksAccess.read
        },
        {
          title: 'Announcements',
          icon: 'mdi-bulletin-board',
          route: '/announcements',
          show: this.announcementsAccess.read
        },
        {
          title: 'Notifications',
          icon: 'mdi-bell-outline',
          route: '/custom',
          show: this.customNotificationsAccess.read
        }
      ]
    },
    logoUrl() {
      return `${process.env.BASE_URL}images/logo-wide-inverted.png`
    },
    logoOnlyUrl() {
      return `https://i.imgur.com/DvyX2QC.jpg`
    },
    rootRole() {
      return this.$root.$role
    },
    user() {
      return this.$store.getters['auth/getUser']
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    checkPropertyLimit() {
      const propertyLimit = this.user.propertyLimit
      const properties = this.user.properties
      return (
        propertyLimit <=
        properties.filter((prop) => prop.role == 'owner').length
      )
    },
    calendarAccess() {
      return this.$root.$roleAccess('calendar').access
    },
    unitsAccess() {
      return this.$root.$roleAccess('units').access
    },
    complaintsAccess() {
      return this.$root.$roleAccess('complaints').access
    },
    violationsAccess() {
      return this.$root.$roleAccess('violations').access
    },
    reservationsAccess() {
      return this.$root.$roleAccess('reservations').access
    },
    paymentAccess() {
      return this.$root.$roleAccess('payment').access
    },
    tenantsAccess() {
      return this.$root.$roleAccess('tenants').access
    },
    linksAccess() {
      return this.$root.$roleAccess('links').access
    },
    announcementsAccess() {
      return this.$root.$roleAccess('announcements').access
    },
    propertyAccess() {
      return this.$root.$roleAccess('property').access
    },
    customNotificationsAccess() {
      return this.$root.$roleAccess('custom_notifications').access
    },
    securityDepositAccess() {
      return this.$root.$roleAccess('security_deposit').access
    },
    downPaymentAccess() {
      return this.$root.$roleAccess('down_payment').access
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    group() {
      this.drawer = false
    }
  },
  mounted() {
    if (this.user.property_details && this.property) {
      this.properties = this.user.property_details.map((property) => {
        return { text: property.propertyName, value: property.propertyId }
      })
      this.currentProperty = this.property.propertyId
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/doLogout')
      // this.$router.go()
      window.location.reload()
    },
    async stopTourCallback() {
      await this.$store.dispatch('auth/stopTour', { section: 'showUnits' })
    },
    noAccess(item) {
      if (this.rootRole) {
        if (this.noAccessRoles[this.rootRole]) {
          return !this.noAccessRoles[this.rootRole].includes(item.title)
        } else {
          return true
        }
      }
      return true
    },
    redirectCreateProperty() {
      this.$router.replace('/new')
    },
    async changeCurrentProperty() {
      this.loading = true
      this.$store
        .dispatch('auth/changeCurrentPropertyAction', {
          propertyId: this.currentProperty
        })
        .then(() => {
          this.loading = false
          window.location.reload()
        })
        .catch((err) => {
          this.loading = false
          if (err == 'EXPIRED_PROPERTY') {
            this.$router.replace('/expired')
          }
        })
    },
    setMini() {
      if (this.mobile) {
        this.drawer = !this.drawer
      } else {
        this.mini = !this.mini
      }
    }
  }
}
</script>

<style scoped>
.v-icon,
.v-list-item__title,
.v-list-item__subtitle {
  color: rgba(255, 255, 255, 0.7) !important;
}
p {
  margin-bottom: 0;
  color: #eeeeee;
}
p.drawer-label {
  font-size: 13px;
}

.v-list-item--active .v-list-item__subtitle,
.v-list-item--active .v-icon {
  color: white !important;
}
</style>
